import { render, staticRenderFns } from "./BranchRetrieveUpdate.vue?vue&type=template&id=64a38e89"
import script from "./BranchRetrieveUpdate.vue?vue&type=script&lang=js"
export * from "./BranchRetrieveUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a38e89')) {
      api.createRecord('64a38e89', component.options)
    } else {
      api.reload('64a38e89', component.options)
    }
    module.hot.accept("./BranchRetrieveUpdate.vue?vue&type=template&id=64a38e89", function () {
      api.rerender('64a38e89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/pos/branch/views/BranchRetrieveUpdate.vue"
export default component.exports